import { render, staticRenderFns } from "./SunsetPageShell.vue?vue&type=template&id=2d2052f1&scoped=true"
import script from "./SunsetPageShell.vue?vue&type=script&lang=js"
export * from "./SunsetPageShell.vue?vue&type=script&lang=js"
import style0 from "./SunsetPageShell.vue?vue&type=style&index=0&id=2d2052f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2052f1",
  null
  
)

export default component.exports